<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
               {{$t('FACEDETECTIONPROPS')}}
            </div>
            <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
              <table class="table table-responsive-sm table-striped">
                <thead>
                  <tr>
                    <th>{{$t('KEY')}}</th>
                    <th>{{$t('DESCRIPTION')}}</th>
                    <th>{{$t('VALUE')}}</th>
                    <th>{{$t('SAVE')}}</th>
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data.root">
                    <td>{{$t(item.desc+'_TITLE')}}</td>
                    <td>{{$t(item.desc+'_DESC')}}</td>
                    <td><b-form-input type="text" v-model="item.value"></b-form-input></td>
                    <td><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="saveRow(item)"><icon icon="save"></icon> {{$t('SAVE')}}</b-button></td>
                  </tr>
                </tbody>
              </table>
              <nav>
              </nav>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Api from '@/api/admin/SiteProps'

export default {
  name: 'SiteProps',
  data: function()
  {
    const me = this;
    return {
      data: {},
      formError: {},
      formData:
      {
        key: '',
        value: ''
      },
      dataProps: {
        idInputSize: 'IDINPUTSIZE',
        idConfidenceThreshold: 'IDCONFIDENCETHRESHOLD',
        faceInputSize: 'FACEINPUTSIZE',
        faceConfidenceThreshold: 'FACECONFIDENCETHRESHOLD',
        genderProbability: 'GENDERPROBABILITY',
      },
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20,
        searchTimeout: false
      }
    }
  },
  created: function()
  {
    var me = this;
    me.getData();
  },
  methods:
  {
    saveRow: function(item)
    {
      var me = this;

      if(typeof item.langId != 'undefined')
      {
        item.id = item.langId;
        delete(item.langId);
      }

      Api.save(item, function(val)
      {
        if(val.error)
        {
          me.$notify.notice(val);
          me.formError = val;
        }
        else
        {
          me.$notify.notice(val);
          me.formError = {};
          me.getData();
        }
      })
    },
    getData: function()
    {
      var me = this;
      Api.selectRow(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }

        const keys = Object.keys(me.dataProps);
        const items = [];
        for (const item of data.root)
        {
            if(keys.indexOf(item.key) !== -1)
            {
                item.desc = me.dataProps[item.key];
                items.push(item);
            }
        }

        me.data = {
            root: items,
        };
      });
    },
    deleteRow: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          Api.deleteRow({id: id}, function(data)
          {
            me.$notify.notice(data);
            me.getData();
          })
        }
      })
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getData();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>
